import { useTranslation } from "react-i18next";
import { Box, Card, CardContent, Container, Grid, Typography } from "@mui/material";
import SpeedRoundedIcon from "@mui/icons-material/SpeedRounded";
import SecurityRoundedIcon from "@mui/icons-material/SecurityRounded";
import CloudSyncRoundedIcon from "@mui/icons-material/CloudSyncRounded";
import InsightsRoundedIcon from "@mui/icons-material/InsightsRounded";
import DevicesRoundedIcon from "@mui/icons-material/DevicesRounded";
import SupportAgentRoundedIcon from "@mui/icons-material/SupportAgentRounded";
import SectionHeading from "../common/SectionHeading";
import { Stagger, StaggerItem } from "../motion/Stagger";
import TiltCard from "../common/TiltCard";

const FEATURES = [
  { icon: SpeedRoundedIcon, key: "perf", color: "#4f7cff" },
  { icon: SecurityRoundedIcon, key: "security", color: "#22c55e" },
  { icon: CloudSyncRoundedIcon, key: "sync", color: "#22d3ee" },
  { icon: InsightsRoundedIcon, key: "analytics", color: "#a855f7" },
  { icon: DevicesRoundedIcon, key: "cross", color: "#f59e0b" },
  { icon: SupportAgentRoundedIcon, key: "support", color: "#ec4899" },
];

export default function Features() {
  const { t } = useTranslation();

  return (
    <Box component="section" sx={{ py: { xs: 8, md: 12 } }}>
      <Container maxWidth="lg">
        <SectionHeading
          eyebrow={t("whyEyebrow")}
          title={t("whyTitle")}
          subtitle={t("whySubtitle")}
        />

        <Stagger>
          <Grid container spacing={3}>
            {FEATURES.map(({ icon: Icon, key, color }) => (
              <Grid item xs={12} sm={6} md={4} key={key}>
                <StaggerItem sx={{ height: "100%" }}>
                  <TiltCard>
                    <Card
                      sx={{
                        height: "100%",
                        p: 1,
                        "&:hover": {
                          transform: "translateY(-6px)",
                          boxShadow: "0 30px 60px -30px rgba(13,18,40,0.55)",
                          borderColor: "primary.main",
                        },
                      }}
                    >
                      <CardContent>
                        <Box
                          sx={{
                            width: 54,
                            height: 54,
                            borderRadius: 3,
                            display: "grid",
                            placeItems: "center",
                            mb: 2.5,
                            color: "#fff",
                            background: `linear-gradient(135deg, ${color}, ${color}99)`,
                            boxShadow: `0 12px 28px -12px ${color}`,
                          }}
                        >
                          <Icon />
                        </Box>
                        <Typography variant="h6" sx={{ mb: 1 }}>
                          {t(`why_${key}_title`)}
                        </Typography>
                        <Typography color="text.secondary">
                          {t(`why_${key}_desc`)}
                        </Typography>
                      </CardContent>
                    </Card>
                  </TiltCard>
                </StaggerItem>
              </Grid>
            ))}
          </Grid>
        </Stagger>
      </Container>
    </Box>
  );
}
